export const marketingMessages = {
  en: {
    "home.hero.note": "Live demo in under 5 minutes • No hardware required",
    "home.hero.videoLabel": "ZediPass promo video",

    "home.why.badge": "CASH-FRIENDLY LOYALTY",
    "home.why.title.prefix": "Compete with",
    "home.why.title.highlight": "corporate chains",
    "home.why.title.suffix": "",
    "home.why.body.line1": "Customer loyalty without the corporate complexity.",
    "home.why.body.line2": "Reward every customer — even when they pay cash.",
    "home.why.cta": "Sign up today",
    "home.why.imageAlt": "Independent street vendor",

    "home.zedipos.badge": "WORKS ALONGSIDE YOUR POS",
    "home.zedipos.title": "Keep your POS. Add powerful loyalty.",
    "home.zedipos.body.line1": "Loyalty apps in POS systems only work if customers bother to sign up.",
    "home.zedipos.body.line2": "ZediPass makes sure they do.",
    "home.zedipos.flow": "Your POS + ZEDIPASS = Instant Loyalty",
    "home.zedipos.features.noIntegration.title": "No integration needed to start",
    "home.zedipos.features.noIntegration.desc": "Start with QR alone — nothing changes in your POS or your till process. Optional Square, SumUp and Dojo integrations come later if you want them.",
    "home.zedipos.features.standalone.title": "Standalone Service",
    "home.zedipos.features.standalone.desc": "Zedipass goes with you. Keep all your app customers if you ever switch POS.",
    "home.zedipos.features.loyaltyFirst.title": "Loyalty-first",
    "home.zedipos.features.loyaltyFirst.desc": "Specialised and flexible loyalty rewards system.",
    "home.zedipos.logoAlt": "POS Logo",

    "home.realtime.badge": "REAL-TIME ANALYTICS",
    "home.realtime.title": "Turn insights into action in real time.",
    "home.realtime.summary": "Track what’s happening as it happens and respond with smart offers, rewards, or follow-ups in seconds.",
    "home.realtime.features.reach.title": "Reach customers instantly",
    "home.realtime.features.reach.desc": "Send updates, rewards or promos the moment customers engage.",
    "home.realtime.features.see.title": "See what’s working",
    "home.realtime.features.see.desc": "Use simple insights to spot trends, adapt fast, and drive loyalty.",
    "home.realtime.features.act.title": "Act on live behavior",
    "home.realtime.features.act.desc": "Smart alerts show you spikes in visits, redemptions, or lapsed users.",

    "home.ready.badge": "THE PLATFORM",
    "home.ready.title.prefix": "Loyalty, simplified.",
    "home.ready.title.highlight": "Ready out the box.",
    "home.ready.summary": "Launch, scan, and start building loyalty — from day one.",

    "home.seeyourself.title": "See Yourself Succeeding",
    "home.seeyourself.subtitle": "Whether you pour coffee, cut hair, or sell flowers — see how ZediPass fits the way your business already works",
    "home.seeyourself.benefitsTitle": "Some benefits:",
    "home.seeyourself.trust.noContracts": "✓ No contracts",
    "home.seeyourself.trust.cancelAnytime": "✓ Cancel anytime",
    "home.seeyourself.trust.tryFree": "✓ try for free",
    "home.seeyourself.industry.coffee.name": "Coffee Shops",
    "home.seeyourself.industry.coffee.desc": "Turn morning regulars into loyal customers with points-based rewards",
    "home.seeyourself.industry.coffee.benefit1": "Daily visit incentives",
    "home.seeyourself.industry.coffee.benefit2": "Automate customer menu updates",
    "home.seeyourself.industry.coffee.benefit3": "Faster than stamping cards",
    "home.seeyourself.industry.flower.name": "Flower Shops",
    "home.seeyourself.industry.flower.desc": "Build lasting relationships beyond special occasions",
    "home.seeyourself.industry.flower.benefit1": "Seasonal campaigns",
    "home.seeyourself.industry.flower.benefit2": "Anniversary reminders",
    "home.seeyourself.industry.flower.benefit3": "Bulk order discounts",
    "home.seeyourself.industry.barber.name": "Barbershops",
    "home.seeyourself.industry.barber.desc": "Keep clients coming back with appointment-based rewards",
    "home.seeyourself.industry.barber.benefit1": "Trim Streak incentives",
    "home.seeyourself.industry.barber.benefit2": "Boost quiet periods",
    "home.seeyourself.industry.barber.benefit3": "Expand customer reach",
    "home.seeyourself.industry.retail.name": "Retail Stores",
    "home.seeyourself.industry.retail.desc": "Drive repeat purchases with personalized shopping rewards",
    "home.seeyourself.industry.retail.benefit1": "Identify and reward VIP customers",
    "home.seeyourself.industry.retail.benefit2": "Provide early access to products",
    "home.seeyourself.industry.retail.benefit3": "Hold time-sensitive flash events",

    "home.measurable.badge": "WHY IT WORKS",
    "home.measurable.title.prefix": "Your regulars are",
    "home.measurable.title.highlight": "your best asset.",
    "home.measurable.summary": "Keep them coming back and they spend more, refer friends, and stick around for years. The numbers prove it.",
    "home.measurable.results.0.title": "More customers kept",
    "home.measurable.results.0.desc": "Industry studies link loyalty programmes to retention gains of up to 45%. Give people a real reason, and they come back.",
    "home.measurable.results.1.title": "More spend per visit",
    "home.measurable.results.1.desc": "Research consistently finds loyalty members spend more per visit — often 20–30% more than one-off customers.",
    "home.measurable.results.2.title": "Return on investment",
    "home.measurable.results.2.desc": "Bain & Company research finds loyalty leaders grow revenue roughly 2.5× faster than industry peers; industry estimates commonly cite a 5–10× return on loyalty spend. It pays for itself fast.",

    "home.how.badge": "SOLUTION",
    "home.how.title": "Here's how it works, in 3 simple steps",
    "home.how.summary": "After sign up, customers are onboarded instantly to all your participating locations — so you capture more repeat visits automatically.",
    "home.how.steps.1.title": "Download & sign up",
    "home.how.steps.1.desc": "Customers download ZediPass and create an account in seconds — no forms, no friction.",
    "home.how.steps.1.tag": "Customer joins once",
    "home.how.steps.1.alt": "Customer holding phone with ZediPass app open",
    "home.how.steps.2.title": "Scan at your till",
    "home.how.steps.2.desc": "Staff scan the customer's code at checkout. Points are added instantly, no extra effort needed.",
    "home.how.steps.2.tag": "Works at every visit",
    "home.how.steps.2.alt": "Staff scanning customer QR code at till",
    "home.how.steps.3.title": "Earn rewards & come back",
    "home.how.steps.3.desc": "Customers unlock real rewards. You get more repeat visits and a loyal customer base — on autopilot.",
    "home.how.steps.3.tag": "More repeat visits",
    "home.how.steps.3.alt": "Happy customers with shopping bags coming back to the store",

    "home.readyCta.title": "Ready to Transform Your Customer Retention?",
    "home.readyCta.summary": "Sign up and Boost repeat business with ZediPass’s frictionless loyalty platform today!",
    "home.readyCta.primary": "Book a Demo",
    "home.readyCta.secondary": "Request Demo",

    "home.prelaunch.badge": "Pilot invite",
    "home.prelaunch.badgeTitle": "Join the prelaunch",
    "home.prelaunch.openAria": "Open ZediPass pilot information",
    "home.prelaunch.modalAria": "Join the ZediPass pilot",
    "home.prelaunch.previewAlt": "ZediPass pilot preview image",
    "home.prelaunch.previewLabel": "Pilot preview",
    "home.prelaunch.chip": "Pilot invite",
    "home.prelaunch.title": "Become a first user of ZediPass",
    "home.prelaunch.subtitle": "2‑month pilot. Full features. We tailor it with you.",
    "home.prelaunch.point1": "Ideal for independents (cafés, stalls, salons, barbers).",
    "home.prelaunch.point2": "2‑month pilot with weekly check‑ins and setup support.",
    "home.prelaunch.point3": "Limited spaces. We’re selecting best‑fit merchants.",
    "home.prelaunch.note": "2‑month pilot • All features unlocked • Limited spaces",
    "home.prelaunch.cta": "Apply for pilot",

    "demo.modal.title": "Schedule Your Personalized Demo",
    "demo.modal.subtitle": "See how ZediPass can transform your customer loyalty program",
    "demo.modal.close": "Close modal",
    "demo.modal.businessName": "Business Name",
    "demo.modal.businessNamePlaceholder": "Business Name",
    "demo.modal.yourName": "Your Name",
    "demo.modal.yourNamePlaceholder": "Your Name",
    "demo.modal.workEmailLabel": "Work Email",
    "demo.modal.workEmailPlaceholder": "Work Email",
    "demo.modal.industryLabel": "Industry",
    "demo.modal.industryPlaceholder": "Industry",
    "demo.modal.discussLabel": "What would you like to discuss?",
    "demo.modal.goalAria": "Select a goal for the demo request",
    "demo.modal.goal.dashboard": "Dashboard Demo",
    "demo.modal.goal.pricing": "Pricing & Subscription",
    "demo.modal.goal.investors": "Investors & Partnerships",
    "demo.modal.goal.general": "General Inquiry",
    "demo.modal.customMessage": "Custom Message",
    "demo.modal.sendRequest": "Send Demo Request →",
    "demo.modal.responseTime": "∙ We’ll respond within 48 hours ∙",
    "demo.modal.signupCta": "Go to Signup",

    "product.cta.bookDemo": "Book Demo",
    "product.cta.startFree": "Get Started",

    "product.hero.eyebrow": "Loyalty Platform",
    "product.hero.title": "Loyalty software built to increase repeat revenue for independent retailers.",
    "product.hero.summary": "Reward returning customers in seconds, track what drives visits, and act on clear insights without replacing your existing setup.",
    "product.hero.bullets.0": "Launch in minutes",
    "product.hero.bullets.1": "Works with your current operations",
    "product.hero.bullets.2": "Designed for measurable repeat visits",
    "product.hero.disclosure.summary": "Need the full rationale behind this approach?",
    "product.hero.disclosure.open": "See details",
    "product.hero.disclosure.close": "Hide details",
    "product.hero.disclosure.details": "ZediPass focuses on the repeat-visit loop: low-friction enrollment, easy redemption, and immediate analytics so operators can adjust campaigns quickly.",

    "product.stats.eyebrow": "Impact Proof",
    "product.stats.title": "Proof that loyalty can deliver measurable growth",
    "product.stats.summary": "Quick outcomes, one line each. Clean signal with low reading load.",
    "product.stats.items.0.label": "Members spend more",
    "product.stats.items.0.implication": "Loyalty members generally increase basket value.",
    "product.stats.items.0.source": "Benchmark trend",
    "product.stats.items.1.label": "They visit more often",
    "product.stats.items.1.implication": "Active loyalty programs raise purchase frequency.",
    "product.stats.items.1.source": "Benchmark trend",
    "product.stats.items.2.label": "Retention vs acquisition",
    "product.stats.items.2.implication": "Retention is typically cheaper than net-new acquisition.",
    "product.stats.items.2.source": "Industry benchmark",
    "product.stats.items.3.label": "Average loyalty return",
    "product.stats.items.3.implication": "Loyalty initiatives can generate strong ROI when executed consistently.",
    "product.stats.items.3.source": "Industry benchmark",

    "product.onboarding.eyebrow": "Onboarding",
    "product.onboarding.title": "Launch in minutes, not weeks",
    "product.onboarding.summary": "A guided rollout that keeps teams focused on customer experience, not setup complexity.",
    "product.onboarding.steps.1.title": "Create your space",
    "product.onboarding.steps.1.desc": "Set brand basics and rewards in a guided setup.",
    "product.onboarding.steps.1.time": "2 minutes",
    "product.onboarding.steps.2.title": "Switch on rewards",
    "product.onboarding.steps.2.desc": "Choose a default flow and launch with confidence.",
    "product.onboarding.steps.2.time": "2 minutes",
    "product.onboarding.steps.3.title": "Start scanning",
    "product.onboarding.steps.3.desc": "Go live and see repeat behavior data immediately.",
    "product.onboarding.steps.3.time": "1 minute",
    "product.onboarding.stepAlt.signup": "Sign Up",
    "product.onboarding.stepAlt.configure": "Configure",
    "product.onboarding.stepAlt.launch": "Launch",

    "product.focus.eyebrow": "Positioning",
    "product.focus.title": "Built for one purpose: measurable customer loyalty",
    "product.focus.summary": "No generic extras. Just the tools independent retailers need to drive repeat visits and understand why they happen.",
    "product.focus.points.0": "No unnecessary modules",
    "product.focus.points.1": "No POS rip-and-replace",
    "product.focus.points.2": "No gimmick mechanics",
    "product.focus.disclosure.summary": "Why focus wins: teams adopt faster when the platform maps directly to one core objective.",
    "product.focus.disclosure.open": "See why focus matters",
    "product.focus.disclosure.close": "Hide details",
    "product.focus.disclosure.details": "Specialized loyalty systems reduce training overhead, make campaign decisions clearer, and improve consistency in execution across locations and staff shifts.",

    "product.final.title": "Ready to improve customer retention?",
    "product.final.summary": "See how your business can launch a loyalty flow that increases repeat visits and gives your team clearer insight.",
    "product.final.cta.primary": "Book Demo",
    "product.final.cta.secondary": "Get Started",

    "product.hiw.eyebrow": "Product Flow",
    "product.hiw.title": "Three apps. One ecosystem.",
    "product.hiw.summary": "Swipe through each experience, or jump with the quick tabs.",
    "product.hiw.tabs.retailer": "Retailer App",
    "product.hiw.tabs.customer": "Customer App",
    "product.hiw.tabs.dashboard": "Analytics Dashboard",
    "product.hiw.retailer.blurb": "Fast scanning and reward redemption for staff.",
    "product.hiw.retailer.bullet1": "Instant customer lookup",
    "product.hiw.retailer.bullet2": "One-tap reward redemption",
    "product.hiw.retailer.bullet3": "Clear team workflow",
    "product.hiw.customer.blurb": "Simple signup and reward tracking for customers.",
    "product.hiw.customer.bullet1": "Points and rewards",
    "product.hiw.customer.bullet2": "Personalized offers",
    "product.hiw.customer.bullet3": "Wallet-ready experience",
    "product.hiw.dashboard.blurb": "Actionable insight into repeat behavior.",
    "product.hiw.dashboard.bullet1": "Live campaign metrics",
    "product.hiw.dashboard.bullet2": "Audience targeting",
    "product.hiw.dashboard.bullet3": "Push scheduling",

    "product.operational.eyebrow": "Operational Simplicity",
    "product.operational.title": "Built to remove friction at the counter",
    "product.operational.summary": "Fast flows for signup, redemption, and daily operations without technical overhead.",
    "product.operational.slides.qr.title": "One QR to enrol, stamp, or redeem",
    "product.operational.slides.qr.summary": "One scan adapts to customer state automatically.",
    "product.operational.slides.qr.details": "New customers join, returning members collect stamps, and reward-ready members redeem with the same QR flow.",
    "product.operational.slides.qr.alt": "Hand holding phone with ZediPass app",
    "product.operational.slides.setup.title": "Instant setup, zero hardware",
    "product.operational.slides.setup.summary": "Launch with your existing devices and process.",
    "product.operational.slides.setup.details": "No POS integration dependency and no hardware shipping delays. Teams can launch fast and iterate without downtime.",
    "product.operational.slides.setup.alt": "Instant loyalty setup",
    "product.operational.slides.paper.title": "Paper cards are outdated",
    "product.operational.slides.paper.summary": "Replace fragile cards with trackable digital loyalty.",
    "product.operational.slides.paper.details": "Paper cards are lost and untracked. ZediPass gives persistent customer history and measurable repeat-visit trends.",
    "product.operational.slides.paper.alt": "Digital loyalty card icon",

    "product.promotions.title1": "Promotions &",
    "product.promotions.title2": "Product Menus",
    "product.promotions.blurb": "Publish menus and product catalogs in minutes.\nPlan promotions and rewards months ahead, then let set-and-forget rules auto-publish and expire items. No POS integration, no extra hardware.",
    "product.promotions.phoneAlt": "ZediPass – Menu",
    "product.promotions.smallTopAlt": "Dashboard preview",
    "product.promotions.tile1Alt": "Promo tile 1",
    "product.promotions.tile2Alt": "Promo tile 2",
    "product.promotions.tile3Alt": "Promo tile 3",

    "product.roi.badge": "ROI CALCULATOR",
    "product.roi.title": "Calculate Your Return On Investment",
    "product.roi.summary": "See how ZediPass pays for itself through increased retention and operational efficiency.",
    "product.roi.disclosure.open": "See methodology",
    "product.roi.disclosure.close": "Hide methodology",
    "product.roi.disclosure.details": "This estimate uses monthly customer volume, average transaction value, and expected retention lift to project additional revenue versus subscription cost.",
    "product.roi.cardTitle": "Café ROI Calculator",
    "product.roi.helpTitle": "How ROI is calculated",
    "product.roi.period.monthly": "Monthly",
    "product.roi.period.yearly": "Yearly",
    "product.roi.metrics.title": "Café Metrics",
    "product.roi.metrics.customers": "Monthly Customers",
    "product.roi.metrics.avgTransaction": "Avg. Transaction",
    "product.roi.metrics.retentionBoost": "Retention Boost",
    "product.roi.metrics.typicalBoost": "Typical retention boost: 10-20% in first 6 months",
    "product.roi.results.title": "Your ROI",
    "product.roi.results.netReturn": "Net Return",
    "product.roi.results.afterFees": "after fees",
    "product.roi.results.cost": "Cost",
    "product.roi.results.perMonth": "/mo",
    "product.roi.results.perYear": "/yr",
    "product.roi.results.roiLabel": "ROI",
    "product.roi.results.annual": "Annual",
    "product.roi.results.multiplier": "Multiplier",
    "product.roi.results.return": "Return",
    "product.roi.results.payback": "Payback",
    "product.roi.results.breakEven": "Break-even",
    "product.roi.results.paybackUnit.singular": "Mo",
    "product.roi.results.paybackUnit.plural": "M",
    "product.roi.results.recommendedTier": "Recommended Tier",
    "product.roi.results.estSignups": "Est. loyalty signups",
    "product.roi.results.perMonthLabel": "/ month",
    "product.roi.results.addedBenefitsTitle": "Added Benefits",
    "product.roi.results.addedBenefitsDetail": "Saves 8-10 staff hours/week • +15-20% customer satisfaction",

    "product.roi.plan.payg.name": "Starter (PAYG)",
    "product.roi.plan.payg.desc": "Best for pop-ups and test launches.",
    "product.roi.plan.payg.coverage": "Usage-based pricing",
    "product.roi.plan.solo.name": "Solo",
    "product.roi.plan.solo.desc": "Up to 500 active loyalty members.",
    "product.roi.plan.solo.coverage": "Up to 500 monthly customers",
    "product.roi.plan.essentials.name": "Essentials",
    "product.roi.plan.essentials.desc": "Up to 2,000 active loyalty members.",
    "product.roi.plan.essentials.coverage": "Up to 2,000 monthly customers",
    "product.roi.plan.expansion.name": "Expansion",
    "product.roi.plan.expansion.desc": "Unlimited loyalty members and automations.",
    "product.roi.plan.expansion.coverage": "Unlimited customers & automations",

    "product.roi.helpModal.title": "What These Numbers Mean",
    "product.roi.helpModal.intro": "ZediPass helps boost customer retention. This calculator shows the extra money you make vs. what you pay.",
    "product.roi.helpModal.step1Title": "1. Extra Revenue",
    "product.roi.helpModal.step1Formula": "Customers × Avg. Spend × Retention Boost",
    "product.roi.helpModal.step2Title": "2. Cost",
    "product.roi.helpModal.step2Prefix": "Recommended subscription tier (PAYG, Solo, Essentials, Expansion) based on your traffic.",
    "product.roi.helpModal.step2Mid": "PAYG includes £",
    "product.roi.helpModal.step2Mid2": " per engagement with a £",
    "product.roi.helpModal.step2Suffix": " monthly minimum.",
    "product.roi.helpModal.step3Title": "3. Net Gain",
    "product.roi.helpModal.step3Formula": "Extra Revenue – Cost",
    "product.roi.helpModal.step4Title": "4. ROI",
    "product.roi.helpModal.step4Formula": "(Net Gain ÷ Cost) × 100",

    "product.health.eyebrow": "Planning Tool",
    "product.health.title": "Loyalty Health Check",
    "product.health.summary": "Get a quick read on where your retention system is leaking value, and what to fix first.",
    "product.health.labels.repeat": "Repeat customer rate",
    "product.health.labels.friction": "Redemption friction",
    "product.health.labels.personalization": "Offer personalization",
    "product.health.labels.consistency": "Campaign consistency",
    "product.health.scoreLabel": "Health score",
    "product.health.status": "Status",
    "product.health.impact": "Estimated impact",
    "product.health.actionsTitle": "Top 3 next actions",
    "product.health.action.repeat": "Increase repeat visit nudges for customers inactive for 14+ days.",
    "product.health.action.friction": "Simplify redemption to one tap and train staff to prompt at checkout.",
    "product.health.action.personalization": "Segment customers by visit behavior and tailor offer frequency.",
    "product.health.action.consistency": "Set a monthly campaign calendar with at least one recurring reward.",
    "product.health.band.strong": "Strong",
    "product.health.band.growing": "Growing",
    "product.health.band.risk": "At Risk",
    "product.health.impact.strong": "+8% to +12% repeat visits",
    "product.health.impact.growing": "+4% to +8% repeat visits",
    "product.health.impact.risk": "+2% to +5% repeat visits",
    "product.health.disclosure.open": "See scoring model",
    "product.health.disclosure.close": "Hide scoring model",
    "product.health.disclosure.details": "Score blends repeat rate, redemption ease, personalization depth, and campaign consistency. Higher repeat and lower friction are weighted most heavily.",

    "product.venn.eyebrow": "Strategic Lens",
    "product.venn.title": "How ZediPass covers every loyalty scenario",
    "product.venn.summary": "Loyalty cards cover cash and card. POS loyalty covers card and analytics. ZediPass covers all three in one system.",
    "product.venn.aria": "Loyalty Cards and POS Loyalty overlap model showing ZediPass covering cash, card, and analytics",

    "product.security.eyebrow": "Trust Layer",
    "product.security.title": "Enterprise-grade security",
    "product.security.summary": "Security standards designed to protect customer data without adding operational burden.",
    "product.security.features.0.title": "Bank-grade encryption",
    "product.security.features.0.desc": "Data is encrypted in transit and at rest.",
    "product.security.features.1.title": "GDPR-ready controls",
    "product.security.features.1.desc": "Customer data handling stays transparent and permission-based.",
    "product.security.features.2.title": "Role-based access",
    "product.security.features.2.desc": "Only the right people access the right information.",
    "product.security.disclosure.summary": "Need deeper compliance context for procurement or legal review?",
    "product.security.disclosure.open": "See compliance details",
    "product.security.disclosure.close": "Hide compliance details",
    "product.security.disclosure.details": "ZediPass security posture includes SOC 2 Type II alignment patterns, PCI-DSS handling practices, and GDPR data governance controls across access, storage, and processing workflows."
  },
  zh: {
    "home.hero.note": "5 分钟内完成演示 • 无需硬件",
    "home.hero.videoLabel": "ZediPass 宣传视频",

    "home.why.badge": "现金友好型忠诚度",
    "home.why.title.prefix": "与",
    "home.why.title.highlight": "连锁品牌",
    "home.why.title.suffix": "同台竞争",
    "home.why.body.line1": "无需企业级复杂度的客户忠诚度。",
    "home.why.body.line2": "即使顾客用现金支付，也能奖励每位顾客。",
    "home.why.cta": "立即注册",
    "home.why.imageAlt": "独立街头摊主",

    "home.zedipos.badge": "兼容各种系统",
    "home.zedipos.title": "保留现有 POS，加上强大的会员体系。",
    "home.zedipos.body.line1": "POS 内置的会员应用只有在顾客愿意注册时才有效。",
    "home.zedipos.body.line2": "ZediPass 确保他们愿意注册。",
    "home.zedipos.flow": "你的 POS + ZEDIPASS = 即时会员体系",
    "home.zedipos.features.noIntegration.title": "无需集成",
    "home.zedipos.features.noIntegration.desc": "使用现有系统即可立即启用，几分钟内融入流程。",
    "home.zedipos.features.standalone.title": "独立服务",
    "home.zedipos.features.standalone.desc": "ZediPass 与你同行。即使更换 POS，也能保留全部会员。",
    "home.zedipos.features.loyaltyFirst.title": "以忠诚度为先",
    "home.zedipos.features.loyaltyFirst.desc": "专注且灵活的会员奖励系统。",
    "home.zedipos.logoAlt": "POS 标识",

    "home.realtime.badge": "实时分析",
    "home.realtime.title": "把洞察实时转化为行动。",
    "home.realtime.summary": "实时追踪发生的一切，用智能优惠、奖励或跟进在数秒内响应。",
    "home.realtime.features.reach.title": "即时触达顾客",
    "home.realtime.features.reach.desc": "顾客互动的瞬间就发送更新、奖励或优惠。",
    "home.realtime.features.see.title": "看清哪些有效",
    "home.realtime.features.see.desc": "用简单洞察发现趋势、快速调整并提升忠诚度。",
    "home.realtime.features.act.title": "根据实时行为行动",
    "home.realtime.features.act.desc": "智能提醒显示来访、兑换高峰或流失用户。",

    "home.ready.badge": "平台概览",
    "home.ready.title.prefix": "忠诚度更简单。",
    "home.ready.title.highlight": "开箱即用。",
    "home.ready.summary": "从第一天起，上线、扫码、开始建立忠诚度。",

    "home.seeyourself.title": "看见自己的成功",
    "home.seeyourself.subtitle": "无论是咖啡店、理发店还是花店——看看 ZediPass 如何融入您现有的经营方式",
    "home.seeyourself.benefitsTitle": "部分收益：",
    "home.seeyourself.trust.noContracts": "✓ 无合同束缚",
    "home.seeyourself.trust.cancelAnytime": "✓ 随时取消",
    "home.seeyourself.trust.tryFree": "✓ 免费试用",
    "home.seeyourself.industry.coffee.name": "咖啡店",
    "home.seeyourself.industry.coffee.desc": "用积分奖励把晨间常客变成忠实会员",
    "home.seeyourself.industry.coffee.benefit1": "每日到访激励",
    "home.seeyourself.industry.coffee.benefit2": "自动推送菜单更新",
    "home.seeyourself.industry.coffee.benefit3": "比盖章卡更快",
    "home.seeyourself.industry.flower.name": "花店",
    "home.seeyourself.industry.flower.desc": "在节日之外也建立长期关系",
    "home.seeyourself.industry.flower.benefit1": "季节性活动",
    "home.seeyourself.industry.flower.benefit2": "周年提醒",
    "home.seeyourself.industry.flower.benefit3": "批量订单优惠",
    "home.seeyourself.industry.barber.name": "理发店",
    "home.seeyourself.industry.barber.desc": "用预约奖励让客户持续回访",
    "home.seeyourself.industry.barber.benefit1": "连续理发奖励",
    "home.seeyourself.industry.barber.benefit2": "提升淡时段客流",
    "home.seeyourself.industry.barber.benefit3": "扩大客户覆盖",
    "home.seeyourself.industry.retail.name": "零售店",
    "home.seeyourself.industry.retail.desc": "用个性化购物奖励带动复购",
    "home.seeyourself.industry.retail.benefit1": "识别并奖励 VIP 客户",
    "home.seeyourself.industry.retail.benefit2": "提供新品优先体验",
    "home.seeyourself.industry.retail.benefit3": "举办限时促销活动",

    "home.measurable.badge": "为何有效",
    "home.measurable.title.prefix": "你的常客是",
    "home.measurable.title.highlight": "最宝贵的资产。",
    "home.measurable.summary": "让他们持续回访，他们会花更多、推荐朋友、长期留下。数据证明这一点。",
    "home.measurable.results.0.title": "留住更多顾客",
    "home.measurable.results.0.desc": "当你给出真正理由时，几乎一半原本会流失的顾客会回来。",
    "home.measurable.results.1.title": "每次消费更多",
    "home.measurable.results.1.desc": "常客不仅回访，每次消费也更高。忠诚度改变购买方式。",
    "home.measurable.results.2.title": "投资回报",
    "home.measurable.results.2.desc": "每投入 £1 的忠诚度预算，通常可带来 £10 回报。很快收回成本。",

    "home.how.badge": "解决方案",
    "home.how.title": "流程如下，3 个简单步骤",
    "home.how.summary": "注册后，顾客会立即在你所有参与门店中完成入会，让你自动捕获更多复购。",
    "home.how.steps.1.title": "下载并注册",
    "home.how.steps.1.desc": "顾客下载 ZediPass，几秒内完成账户创建——无需填写表单。",
    "home.how.steps.1.tag": "顾客一次入会",
    "home.how.steps.1.alt": "顾客手持打开 ZediPass 应用的手机",
    "home.how.steps.2.title": "在收银台扫码",
    "home.how.steps.2.desc": "收银时员工扫码即可立即记分，无需额外操作。",
    "home.how.steps.2.tag": "每次到访都适用",
    "home.how.steps.2.alt": "员工在收银台扫描顾客二维码",
    "home.how.steps.3.title": "获得奖励并回访",
    "home.how.steps.3.desc": "顾客解锁真实奖励，你获得更多复购与忠诚客户——自动运行。",
    "home.how.steps.3.tag": "更多复购",
    "home.how.steps.3.alt": "顾客提着购物袋回到门店",

    "home.readyCta.title": "准备好提升客户留存了吗？",
    "home.readyCta.summary": "立即注册，用 ZediPass 无摩擦会员平台提升复购！",
    "home.readyCta.primary": "开始免费试用",
    "home.readyCta.secondary": "申请演示",

    "home.prelaunch.badge": "试点邀请",
    "home.prelaunch.badgeTitle": "加入内测",
    "home.prelaunch.openAria": "打开 ZediPass 试点信息",
    "home.prelaunch.modalAria": "加入 ZediPass 试点",
    "home.prelaunch.previewAlt": "ZediPass 试点预览图片",
    "home.prelaunch.previewLabel": "试点预览",
    "home.prelaunch.chip": "试点邀请",
    "home.prelaunch.title": "成为 ZediPass 首批用户",
    "home.prelaunch.subtitle": "为期 2 个月的试点，功能全开，并与你共同定制。",
    "home.prelaunch.point1": "适合独立商家（咖啡馆、摊位、美发店、理发店）。",
    "home.prelaunch.point2": "2 个月试点，含每周回访与上线支持。",
    "home.prelaunch.point3": "名额有限，我们将选择最适合的商家。",
    "home.prelaunch.note": "2 个月试点 • 全功能开放 • 名额有限",
    "home.prelaunch.cta": "申请试点",

    "demo.modal.title": "预约你的专属演示",
    "demo.modal.subtitle": "看看 ZediPass 如何改变你的会员体系",
    "demo.modal.close": "关闭窗口",
    "demo.modal.businessName": "商家名称",
    "demo.modal.businessNamePlaceholder": "商家名称",
    "demo.modal.yourName": "你的姓名",
    "demo.modal.yourNamePlaceholder": "你的姓名",
    "demo.modal.workEmailLabel": "工作邮箱",
    "demo.modal.workEmailPlaceholder": "工作邮箱",
    "demo.modal.industryLabel": "行业",
    "demo.modal.industryPlaceholder": "行业",
    "demo.modal.discussLabel": "你想讨论什么？",
    "demo.modal.goalAria": "选择演示需求",
    "demo.modal.goal.dashboard": "仪表盘演示",
    "demo.modal.goal.pricing": "价格与订阅",
    "demo.modal.goal.investors": "投资与合作",
    "demo.modal.goal.general": "一般咨询",
    "demo.modal.customMessage": "自定义信息",
    "demo.modal.sendRequest": "发送演示申请 →",
    "demo.modal.responseTime": "∙ 我们将在 48 小时内回复 ∙",
    "demo.modal.signupCta": "前往注册",

    "product.cta.bookDemo": "预约演示",
    "product.cta.startFree": "免费开始",

    "product.hero.eyebrow": "会员平台",
    "product.hero.title": "为独立零售商提升复购收入的会员软件。",
    "product.hero.summary": "几秒内奖励回访顾客，追踪复购驱动因素，并在不替换现有系统的情况下依据清晰洞察行动。",
    "product.hero.bullets.0": "分钟级上线",
    "product.hero.bullets.1": "兼容现有运营流程",
    "product.hero.bullets.2": "专为可衡量的复购设计",
    "product.hero.disclosure.summary": "想了解这一方法的完整逻辑？",
    "product.hero.disclosure.open": "查看详情",
    "product.hero.disclosure.close": "收起详情",
    "product.hero.disclosure.details": "ZediPass 聚焦复购闭环：低摩擦入会、轻松兑换与即时分析，让运营团队能快速调整活动。",

    "product.stats.eyebrow": "成效证明",
    "product.stats.title": "证明忠诚度可以带来可衡量的增长",
    "product.stats.summary": "每条一句话，快速读出结果，信息清晰。",
    "product.stats.items.0.label": "会员消费更多",
    "product.stats.items.0.implication": "会员通常会提高客单价。",
    "product.stats.items.0.source": "基准趋势",
    "product.stats.items.1.label": "到访更频繁",
    "product.stats.items.1.implication": "活跃的会员体系会提高购买频次。",
    "product.stats.items.1.source": "基准趋势",
    "product.stats.items.2.label": "留存相对获客",
    "product.stats.items.2.implication": "留存通常比新获客成本更低。",
    "product.stats.items.2.source": "行业基准",
    "product.stats.items.3.label": "平均忠诚度回报",
    "product.stats.items.3.implication": "持续执行的忠诚度项目可带来强劲 ROI。",
    "product.stats.items.3.source": "行业基准",

    "product.onboarding.eyebrow": "上手引导",
    "product.onboarding.title": "分钟级上线，而非数周",
    "product.onboarding.summary": "引导式上线，让团队专注顾客体验，而非复杂设置。",
    "product.onboarding.steps.1.title": "创建你的空间",
    "product.onboarding.steps.1.desc": "在引导流程中设置品牌基础和奖励。",
    "product.onboarding.steps.1.time": "2 分钟",
    "product.onboarding.steps.2.title": "开启奖励",
    "product.onboarding.steps.2.desc": "选择默认流程，自信上线。",
    "product.onboarding.steps.2.time": "2 分钟",
    "product.onboarding.steps.3.title": "开始扫码",
    "product.onboarding.steps.3.desc": "上线后立即看到复购行为数据。",
    "product.onboarding.steps.3.time": "1 分钟",
    "product.onboarding.stepAlt.signup": "注册",
    "product.onboarding.stepAlt.configure": "配置",
    "product.onboarding.stepAlt.launch": "上线",

    "product.focus.eyebrow": "定位",
    "product.focus.title": "只为一个目标：可衡量的客户忠诚度",
    "product.focus.summary": "没有泛用功能，只有独立零售商所需的工具，提升复购并理解原因。",
    "product.focus.points.0": "没有不必要的模块",
    "product.focus.points.1": "无需替换 POS",
    "product.focus.points.2": "不靠噱头机制",
    "product.focus.disclosure.summary": "聚焦的原因：当平台直接对应一个核心目标时，团队采用更快。",
    "product.focus.disclosure.open": "了解聚焦为何重要",
    "product.focus.disclosure.close": "收起详情",
    "product.focus.disclosure.details": "专注的忠诚度系统可降低培训负担，让活动决策更清晰，并提升不同门店与班次的执行一致性。",

    "product.final.title": "准备好提升客户留存了吗？",
    "product.final.summary": "看看你的企业如何上线会员流程，提升复购并让团队获得更清晰的洞察。",
    "product.final.cta.primary": "预约演示",
    "product.final.cta.secondary": "免费开始",

    "product.hiw.eyebrow": "产品流程",
    "product.hiw.title": "三款应用，一个生态",
    "product.hiw.summary": "滑动浏览每个体验，或用快捷标签直接跳转。",
    "product.hiw.tabs.retailer": "商家端应用",
    "product.hiw.tabs.customer": "顾客端应用",
    "product.hiw.tabs.dashboard": "数据分析面板",
    "product.hiw.retailer.blurb": "为员工提供快速扫码与兑换。",
    "product.hiw.retailer.bullet1": "即时客户查找",
    "product.hiw.retailer.bullet2": "一键奖励兑换",
    "product.hiw.retailer.bullet3": "清晰的团队流程",
    "product.hiw.customer.blurb": "简洁的注册与奖励追踪。",
    "product.hiw.customer.bullet1": "积分与奖励",
    "product.hiw.customer.bullet2": "个性化优惠",
    "product.hiw.customer.bullet3": "支持钱包的体验",
    "product.hiw.dashboard.blurb": "可执行的复购洞察。",
    "product.hiw.dashboard.bullet1": "实时活动指标",
    "product.hiw.dashboard.bullet2": "人群定向",
    "product.hiw.dashboard.bullet3": "推送排期",

    "product.operational.eyebrow": "运营简化",
    "product.operational.title": "为收银台去除阻力",
    "product.operational.summary": "注册、兑换与日常运营的快速流程，无需技术负担。",
    "product.operational.slides.qr.title": "一个二维码用于入会、集章或兑换",
    "product.operational.slides.qr.summary": "一次扫描自动识别顾客状态。",
    "product.operational.slides.qr.details": "新顾客入会、老会员集章、可兑换会员用同一流程完成。",
    "product.operational.slides.qr.alt": "手持手机展示 ZediPass 应用",
    "product.operational.slides.setup.title": "即装即用，无需硬件",
    "product.operational.slides.setup.summary": "用现有设备与流程即可上线。",
    "product.operational.slides.setup.details": "不依赖 POS 集成，无需等待硬件配送。团队可快速上线并持续迭代。",
    "product.operational.slides.setup.alt": "即时会员设置",
    "product.operational.slides.paper.title": "纸质卡片已过时",
    "product.operational.slides.paper.summary": "用可追踪的数字会员替代易损卡片。",
    "product.operational.slides.paper.details": "纸质卡容易丢失且无法追踪。ZediPass 提供持续的客户历史和可衡量的复购趋势。",
    "product.operational.slides.paper.alt": "数字会员卡图标",

    "product.promotions.title1": "促销与",
    "product.promotions.title2": "产品菜单",
    "product.promotions.blurb": "几分钟内发布菜单和产品目录。\n提前数月规划促销与奖励，然后用设置即忘的规则自动发布并到期下架。无需 POS 集成，也无需额外硬件。",
    "product.promotions.phoneAlt": "ZediPass – 菜单",
    "product.promotions.smallTopAlt": "仪表盘预览",
    "product.promotions.tile1Alt": "促销卡片 1",
    "product.promotions.tile2Alt": "促销卡片 2",
    "product.promotions.tile3Alt": "促销卡片 3",

    "product.roi.badge": "ROI 计算器",
    "product.roi.title": "计算你的投资回报",
    "product.roi.summary": "看看 ZediPass 如何通过提升留存与运营效率实现自我回本。",
    "product.roi.disclosure.open": "查看方法",
    "product.roi.disclosure.close": "收起方法",
    "product.roi.disclosure.details": "该估算使用月客流、平均客单价与预期留存提升，来预测新增收入与订阅成本的差值。",
    "product.roi.cardTitle": "咖啡店 ROI 计算器",
    "product.roi.helpTitle": "ROI 如何计算",
    "product.roi.period.monthly": "按月",
    "product.roi.period.yearly": "按年",
    "product.roi.metrics.title": "咖啡店指标",
    "product.roi.metrics.customers": "月客流",
    "product.roi.metrics.avgTransaction": "平均客单价",
    "product.roi.metrics.retentionBoost": "留存提升",
    "product.roi.metrics.typicalBoost": "常见留存提升：前 6 个月为 10–20%",
    "product.roi.results.title": "你的 ROI",
    "product.roi.results.netReturn": "净回报",
    "product.roi.results.afterFees": "扣除费用后",
    "product.roi.results.cost": "成本",
    "product.roi.results.perMonth": "/月",
    "product.roi.results.perYear": "/年",
    "product.roi.results.roiLabel": "ROI",
    "product.roi.results.annual": "年度",
    "product.roi.results.multiplier": "回报倍数",
    "product.roi.results.return": "回报",
    "product.roi.results.payback": "回本周期",
    "product.roi.results.breakEven": "盈亏平衡",
    "product.roi.results.paybackUnit.singular": "个月",
    "product.roi.results.paybackUnit.plural": "个月",
    "product.roi.results.recommendedTier": "推荐方案",
    "product.roi.results.estSignups": "预计会员注册",
    "product.roi.results.perMonthLabel": "/ 月",
    "product.roi.results.addedBenefitsTitle": "额外收益",
    "product.roi.results.addedBenefitsDetail": "每周节省 8–10 小时人力 • 客户满意度提升 15–20%",

    "product.roi.plan.payg.name": "入门（PAYG）",
    "product.roi.plan.payg.desc": "适合快闪店与试点上线。",
    "product.roi.plan.payg.coverage": "按使用量计费",
    "product.roi.plan.solo.name": "Solo",
    "product.roi.plan.solo.desc": "最多 500 名活跃会员。",
    "product.roi.plan.solo.coverage": "每月最多 500 名顾客",
    "product.roi.plan.essentials.name": "Essentials",
    "product.roi.plan.essentials.desc": "最多 2,000 名活跃会员。",
    "product.roi.plan.essentials.coverage": "每月最多 2,000 名顾客",
    "product.roi.plan.expansion.name": "Expansion",
    "product.roi.plan.expansion.desc": "不限会员数量与自动化。",
    "product.roi.plan.expansion.coverage": "不限顾客与自动化",

    "product.roi.helpModal.title": "这些数字代表什么",
    "product.roi.helpModal.intro": "ZediPass 可提升客户留存。本计算器展示你获得的额外收益与成本对比。",
    "product.roi.helpModal.step1Title": "1. 额外收入",
    "product.roi.helpModal.step1Formula": "顾客数 × 平均客单价 × 留存提升",
    "product.roi.helpModal.step2Title": "2. 成本",
    "product.roi.helpModal.step2Prefix": "根据客流量推荐订阅方案（PAYG、Solo、Essentials、Expansion）。",
    "product.roi.helpModal.step2Mid": "PAYG 每次互动 £",
    "product.roi.helpModal.step2Mid2": "，月最低 £",
    "product.roi.helpModal.step2Suffix": "。",
    "product.roi.helpModal.step3Title": "3. 净收益",
    "product.roi.helpModal.step3Formula": "额外收入 – 成本",
    "product.roi.helpModal.step4Title": "4. ROI",
    "product.roi.helpModal.step4Formula": "（净收益 ÷ 成本）× 100",

    "product.health.eyebrow": "规划工具",
    "product.health.title": "忠诚度健康检查",
    "product.health.summary": "快速判断你的留存系统在哪些环节流失价值，以及优先修复什么。",
    "product.health.labels.repeat": "复购率",
    "product.health.labels.friction": "兑换阻力",
    "product.health.labels.personalization": "优惠个性化",
    "product.health.labels.consistency": "活动持续性",
    "product.health.scoreLabel": "健康评分",
    "product.health.status": "状态",
    "product.health.impact": "预计影响",
    "product.health.actionsTitle": "接下来 3 个行动",
    "product.health.action.repeat": "对 14 天以上未回访的顾客加强复购提醒。",
    "product.health.action.friction": "将兑换简化为一键，并培训员工在结账时提示。",
    "product.health.action.personalization": "按到访行为细分顾客，调整优惠频率。",
    "product.health.action.consistency": "制定每月活动日历，至少设定一个固定奖励。",
    "product.health.band.strong": "强劲",
    "product.health.band.growing": "成长中",
    "product.health.band.risk": "有风险",
    "product.health.impact.strong": "复购提升 +8% 至 +12%",
    "product.health.impact.growing": "复购提升 +4% 至 +8%",
    "product.health.impact.risk": "复购提升 +2% 至 +5%",
    "product.health.disclosure.open": "查看评分模型",
    "product.health.disclosure.close": "收起评分模型",
    "product.health.disclosure.details": "评分结合复购率、兑换便捷度、个性化深度与活动持续性。更高复购与更低阻力权重更高。",

    "product.venn.eyebrow": "战略视角",
    "product.venn.title": "ZediPass 如何覆盖所有忠诚度场景",
    "product.venn.summary": "会员卡覆盖现金与刷卡，POS 会员覆盖刷卡与分析，ZediPass 一套系统覆盖三者。",
    "product.venn.aria": "会员卡与 POS 会员的重叠模型，显示 ZediPass 覆盖现金、刷卡与分析",

    "product.security.eyebrow": "信任层",
    "product.security.title": "企业级安全",
    "product.security.summary": "旨在保护客户数据的安全标准，不增加运营负担。",
    "product.security.features.0.title": "银行级加密",
    "product.security.features.0.desc": "数据在传输与存储中均加密。",
    "product.security.features.1.title": "GDPR 就绪",
    "product.security.features.1.desc": "客户数据处理透明且基于授权。",
    "product.security.features.2.title": "基于角色的访问",
    "product.security.features.2.desc": "只有合适的人能访问合适的信息。",
    "product.security.disclosure.summary": "需要更深入的合规背景用于采购或法务审查？",
    "product.security.disclosure.open": "查看合规细节",
    "product.security.disclosure.close": "收起合规细节",
    "product.security.disclosure.details": "ZediPass 的安全体系包含 SOC 2 Type II 对齐实践、PCI-DSS 处理规范，以及覆盖访问、存储与处理流程的 GDPR 数据治理控制。"
  }
};
